export enum MessageStatusEnum {
  Draft = 'Draft',
  Scheduled = 'Scheduled',
  Processing = 'Processing',
  Sent = 'Sent',
  PartiallyFailed = 'PartiallyFailed',
  Failed = 'Failed',
  Cancelled = 'Cancelled'
}

export const MESSAGE_STATUS_ENUM_RECORD: Record<MessageStatusEnum, string> = {
  [MessageStatusEnum.Draft]: 'Draft',
  [MessageStatusEnum.Scheduled]: 'Scheduled',
  [MessageStatusEnum.Processing]: 'Processing',
  [MessageStatusEnum.Sent]: 'Sent',
  [MessageStatusEnum.PartiallyFailed]: 'Partially Failed',
  [MessageStatusEnum.Failed]: 'Failed',
  [MessageStatusEnum.Cancelled]: 'Cancelled'
};
